/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutConfirmRegionController', function ($scope, $q, $element, CommonUtils) {
            
            $scope.Locked = false;
            $scope.Step = 'Confirmation';
            $scope.Config = {};

            var controls = [];
            $scope.registerControl = function (name, control) {
                if ($scope[name] === undefined) {
                    $scope[name] = {
                        Wrapper: control,
                        Current: undefined
                    };
                    controls.push(control);
                }
            };
            $scope.setControlValue = function (name, value) {
                if ($scope[name] === undefined)
                    throw new Error(name + ' is not registered as a control on the shared $scope');

                $scope[name].Current = value;
            };

            $scope.previous = function () {
                $scope.cancel();
            };

            $scope.cancel = function () {
                if (!$scope.Locked) {
                    $scope.Locked = true;
                    document.location = '/engine/cancelPayPalOrder';
                }
            };

            $scope.proceed = function () {
                if (!$scope.Locked) {
                    $scope.Locked = true;
                    document.location = '/engine/completePayPalOrder';
                }
            };

        });
})();